import { Form, Offcanvas, Button, InputGroup } from "react-bootstrap";
import { FiPlusSquare } from "react-icons/fi";
import { GoTrash } from "react-icons/go";

const AdvanceScheduler = ({
  show,
  hide,
  title,
  DAYS,
  initialSchedulerSettings,
  setWidgetSchedulerSettings,
  widgetSchedulerSettings,
  isScheduleDifferent,
}) => {

  const updateWidgetOperationTimezoneSettings = (value) => {
    setWidgetSchedulerSettings((prev) => ({
      ...prev,
      ["operationTimezone"]: value,
    }));
  };

  const toggleDay = (day) => {
    setWidgetSchedulerSettings((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        enabled: !prev[day].enabled,
      },
    }));
  };

  const addPeriod = (day) => {
    setWidgetSchedulerSettings((prev) => {
      const periods = prev[day].periods;
      return {
        ...prev,
        [day]: {
          ...prev[day],
          periods: [...periods, { from: "", to: "" }],
        },
      };
    });
  };

  const removePeriod = (day, index) => {
    setWidgetSchedulerSettings((prev) => {
      const periods = prev[day].periods;
      if (periods.length === 1) return prev;
      return {
        ...prev,
        [day]: {
          ...prev[day],
          periods: periods.filter((_, i) => i !== index),
        },
      };
    });
  };

  const updatePeriod = (day, index, field, value) => {
    setWidgetSchedulerSettings((prev) => {
      const periods = [...prev[day].periods];
      periods[index] = { ...periods[index], [field]: value };
      return {
        ...prev,
        [day]: {
          ...prev[day],
          periods,
        },
      };
    });
  };

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group>
          <Form.Label>Operating Timezone</Form.Label>
          <Form.Select
            size="sm"
            name="requireConsent"
            value={widgetSchedulerSettings?.operationTimezone}
            onChange={(e) => updateWidgetOperationTimezoneSettings(e.target.value)}
          >
            <option value={""}>Select Timezone</option>
            <option value={"india"}>India</option>
            <option value={"usa"}>USA</option>
          </Form.Select>
        </Form.Group>
        <Form>
          {DAYS.map((day) => (
            <Form.Group
              key={day}
              className="p-3 mb-4 mt-2 rounded position-relative bg-light"
              style={{ border: "1px dashed var(--border-color)" }}
            >
              <div
                className="position-absolute bg-light border rounded px-3"
                style={{ top: -14 }}
              >
                <Form.Check
                  type="switch"
                  label={day}
                  checked={widgetSchedulerSettings?.[day]?.enabled}
                  onChange={() => toggleDay(day)}
                  className="fw-bold m-0 mt-2"
                  style={{ fontSize: 11 }}
                />
              </div>
              <Form.Label className="mt-2 d-flex align-items-center gap-1">
                Select Period
                {widgetSchedulerSettings?.[day]?.enabled && (
                  <FiPlusSquare
                    className="CP text-primary"
                    title="Add More"
                    onClick={() => addPeriod(day)}
                  />
                )}
              </Form.Label>
              {widgetSchedulerSettings?.[day]?.periods.map((period, index) => (
                <InputGroup className="mb-2" key={index}>
                  <Form.Control
                    type="time"
                    disabled={!widgetSchedulerSettings?.[day]?.enabled}
                    value={period.from}
                    onChange={(e) =>
                      updatePeriod(day, index, "from", e.target.value)
                    }
                  />
                  <Form.Control
                    type="time"
                    disabled={!widgetSchedulerSettings?.[day]?.enabled}
                    value={period.to}
                    onChange={(e) =>
                      updatePeriod(day, index, "to", e.target.value)
                    }
                  />
                  {widgetSchedulerSettings?.[day]?.enabled &&
                    widgetSchedulerSettings?.[day]?.periods?.length > 1 && (
                      <InputGroup.Text
                        className="CP"
                        title="Delete Period"
                        onClick={() => removePeriod(day, index)}
                      >
                        <GoTrash className="text-danger" size={12} />
                      </InputGroup.Text>
                    )}
                </InputGroup>
              ))}
            </Form.Group>
          ))}
          {isScheduleDifferent() &&
            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => setWidgetSchedulerSettings(initialSchedulerSettings(["Sunday"], "09:00, 17:00"))}
              >
                Reset
              </Button>
            </div>
          }
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AdvanceScheduler;
